module.exports = __webpack_public_path__ + "img/9@2x.6a9478ff.png";